import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { useLanguage } from "../../Translations/LenguageContext";
import NoFilesFound from "../CloudStorage/NoFilesFound";
import { VscOpenPreview } from "react-icons/vsc";
import { BiCopy } from "react-icons/bi";


const TableCloud = ({ data, handleActionClick, handleOpenShareModal, selectedFiles, handleCheckboxChange, ShowPreview }) => {
  const { t } = useLanguage();
  const [sortedData, setSortedData] = useState(data || []);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [copiedId, setCopiedId] = useState(null);

  useEffect(() => {
    setSortedData(data);
  }, [data]);

  const headers = sortedData.length > 0 ? Object.keys(sortedData[0]) : [];

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sorted = [...sortedData].sort((a, b) => {
      const aValue = a[key]?.value || "";
      const bValue = b[key]?.value || "";

      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setSortedData(sorted);
    setSortConfig({ key, direction });
  };

  const handleIdClick = (id) => {
    navigator.clipboard.writeText(id).then(() => {
      setCopiedId(id);
      setTimeout(() => {
        setCopiedId(null);
      }, 3000);
    });
  };

  const isImageUrl = (url) => {
    const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|tiff)$/i;
    return imageExtensions.test(url);
  };

  const handleFileClick = (url, filename) => {
    if (url) {
      const a = document.createElement("a");
      a.href = url;
      a.download = "file";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  if (sortedData.length === 0) {
    return <NoFilesFound />;
  }

  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th style={{ width: "30px" }}>
              <input
                type="checkbox"
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  data.forEach((row) => handleCheckboxChange(row._id.value, isChecked));
                }}
                checked={data.length > 0 && data.every((row) => selectedFiles.includes(row._id.value))}
              />
            </th>

            {headers.map((header) => (
              <th
                key={header}
                onClick={() => handleSort(header)}
                style={{ cursor: "pointer" }}
                aria-sort={
                  sortConfig.key === header
                    ? sortConfig.direction === "asc"
                      ? "ascending"
                      : "descending"
                    : "none"
                }
                className={sortConfig.key === header ? "active-sort" : ""}
              >
                {sortedData[0][header]?.label || header}{" "}
                {sortConfig.key === header ? (
                  sortConfig.direction === "asc" ? (
                    <i className="fa-solid fa-arrow-up"></i>
                  ) : (
                    <i className="fa-solid fa-arrow-down"></i>
                  )
                ) : null}
              </th>
            ))}
            <th style={{ width: "40px" }}></th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((row, rowIndex) => (
            <tr key={rowIndex}>
              <td style={{ width: "30px" }}>
                <input
                  type="checkbox"
                  onChange={(e) => handleCheckboxChange(row._id.value, e.target.checked)}
                  checked={selectedFiles.includes(row._id.value)}

                />
              </td>

              {headers.map((header) => {
                const cellData = row[header];
                const cellType = cellData?.type || "default";
                let customClass = `${cellType}_cell`;

                return (
                  <td
                    key={`${rowIndex}-${header}`}
                    className={`cell-${cellType}`}
                    onClick={cellType === "_id" ? () => handleIdClick(row[header].value) : undefined}
                  >
                    <div
                      className={`${customClass} ${copiedId === row._id?.value ? "copied_item" : ""}`}
                      title={cellData?.value}
                    >
                      {cellType === "_id" ? (
                        <div className="id_cell">
                          <p>{cellData?.value}</p>
                          <BiCopy style={{ marginLeft: "8px" }} />
                        </div>
                      ) : cellType === "file" ? (
                        <p className="icon_cloud" onClick={() => ShowPreview(cellData?.value, row.name.value)} >
                          <VscOpenPreview/>
                        </p>
                      ) : cellType === "status" ? (
                        <>
                          {cellData?.value == "deleted" ? (
                            <div className="deleted_item_circle"></div>
                          ) : (
                            <div className="success_item_circle"></div>
                          )}
                        </>
                      ) : (
                        <>{cellData?.value}</>
                      )}
                    </div>
                  </td>
                );
              })}
              <td style={{ textAlign: "center" }}>
                <Dropdown>
                  <div className="property_btn_action_toggle">
                    <Dropdown.Toggle className="custom-dropdown-toggle" as="div">
                      <i className="fa-solid fa-ellipsis-vertical"></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="custom-dropdown-menu">
                      {row.status.value === "deleted" ? (
                        <>
                          <Dropdown.Item
                            className="drop_down_item activate"
                            onClick={() => {
                              handleActionClick(row._id?.value, "activate");
                            }}
                          >
                            <i className="fa-solid fa-check"></i> {t.cloud.restore}
                          </Dropdown.Item>
                          <Dropdown.Item
                            className="drop_down_item delete"
                            onClick={() => {
                              handleActionClick(row._id?.value, "delete_permanently");
                            }}
                          >
                            <i className="fa-solid fa-x"></i> {t.cloud.delete_permanently}
                          </Dropdown.Item>
                        </>
                      ) : (
                        <>
                          <Dropdown.Item
                            className="drop_down_item"
                            onClick={() => {
                              handleOpenShareModal(row._id?.value, "share");
                            }}
                          >
                            <i className="fa-solid fa-share"></i> {t.cloud.share}
                          </Dropdown.Item>
                          <Dropdown.Item
                            className="drop_down_item delete"
                            onClick={() => {
                              handleActionClick(row._id?.value, "delete_temporarily");
                            }}
                          >
                            <i className="fa-solid fa-trash"></i> {t.delete}
                          </Dropdown.Item>
                        </>
                      )}

                    </Dropdown.Menu>
                  </div>
                </Dropdown>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableCloud;
